export default "__VITE_ASSET__DWerXpdc__"